module.exports = __webpack_public_path__ + "9d83d7bd641595f823938786321b38f4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/client/fonts/Interstate-Regular.ttf
// module id = 970
// module chunks = 0